<template>
  <v-container class="pt-6">
    <v-card class="elevation-2 mb-6">
      <v-card-title class="px-9 pt-7">
        Přehled tiskáren
      </v-card-title>

      <v-card-text>

        <PrintersFilters @filter="setFiltersAction" :customer="true"/>

        <v-data-table
          :headers="printer.headers"
          :items="printer.items"
          :options.sync="printer.options"
          :server-items-length="printer.serverItemsLength"
          :loading="printer.loading"
          item-key="serialNumber"
          class="elevation-0"
        >
          <template v-slot:item.serialNumber="{ item }">
            <router-link :to="{
              name: 'customer.printers.detail',
              params: { serialNumber: item.serialNumber }
            }">
              {{ item.serialNumber }}
            </router-link>
          </template>

          <template v-slot:item.createdAt="{ item }">
            {{ $dayjs(item.createdAt).format('D.M.YYYY') }}
            <br>
            {{ $dayjs(item.createdAt).format('H:mm') }}
          </template>

          <template v-slot:item.updatedAt="{ item }">
            {{ $dayjs(item.updatedAt).format('D.M.YYYY') }}
            <br>
            {{ $dayjs(item.updatedAt).format('H:mm') }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import PrintersFilters from '@/components/PrintersFilters.vue';
import { setFilters } from '@/components/mixins/setFilters';

export default {
  name: 'CustomerPrintersAll',
  mixins: [setFilters],
  components: {
    PrintersFilters,
  },
  data() {
    return {
      printer: {
        headers: [
          {
            text: 'Sériové číslo',
            value: 'serialNumber',
            width: '60px',
          },
          {
            text: 'Název',
            value: 'name',
            width: '160px',
          },
          {
            text: 'Stav',
            value: 'status',
            width: '60px',
            sortable: false,
          },
          {
            text: 'Stav zařízení',
            value: 'statusDevice',
            width: '60px',
            sortable: false,
          },
          {
            text: 'Chyba',
            value: 'errorState',
            width: '60px',
            sortable: false,
          },
          {
            text: 'Upraveno',
            value: 'updatedAt',
            width: '60px',
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 100,
          sortBy: ['serialNumber'],
          sortDesc: [false],
        },
        loading: false,
        serverItemsLength: 0,
      },
      printerFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    };
  },
  methods: {
    ...mapActions({
      searchPrinters: 'customer/searchPrinters',
    }),
    loadPrinters() {
      if (this.printer.loading) {
        return;
      }
      this.printer.loading = true;
      const searchParams = {
        filterParams: this.$route.query,
        options: this.printer.options,
      };
      searchParams.filterParams.code = this.$route.params.code;
      this.searchPrinters(searchParams).then((response) => {
        this.printerFooter.totalElements = response.data.totalElements;
        this.printer.items = response.data.items;
        this.printer.serverItemsLength = response.data.totalElements;
        this.cancel = null;
      }).finally(() => {
        this.printer.loading = false;
      });
    },
    setFiltersAction(filters) {
      this.printer.options.page = 1;
      this.setFilters(filters);
    },
  },
  watch: {
    'printer.options': {
      handler() {
        this.loadPrinters();
      },
    },
    '$route.query': {
      handler() {
        this.loadPrinters();
      },
    },
  },
  created() {
    this.loadPrinters();
  },
};
</script>
